import * as yup from "yup";
import {
    emailRule,
    textRule,
} from "../commonRules";

export const AddNewUserSchema = yup.object().shape({
    email: emailRule("Email", { required: true }),
    user_type: textRule("Allowed Recruiters", { required: true }),
});

export default AddNewUserSchema;
